// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__18whI","loaderOuter":"PageOverlayLoader_loaderOuter__34w8g"};